/**
 * Ghost/outline button treatment for CTAs placed on a dark (bg-secondary)
 * band, where the default `outline` variant's opaque bg-background would
 * clash. Shared across every page with a dark hero/CTA band.
 */
export const outlineOnDarkClass =
  'border-secondary-foreground/30 bg-transparent text-secondary-foreground hover:bg-secondary-foreground/10 hover:text-secondary-foreground';
